module.exports = __webpack_public_path__ + "static/media/sabrina_results.5b6463a5.png";